import { z } from 'zod';
import { marketingOptOutSchema } from '@/components/Forms/components/MarketingOptOut/validation';
import excludedEmailDomains from '@/components/Forms/constants/excludedEmailDomains';

const EIGHTY_CHARACTER_LIMIT = 80;
const FORTY_CHARACTER_LIMIT = 40;

export const editionsContactFormSchema = z.object({
  form_type: z.literal('editions_contact_form'),
  edition: z.enum(['data_center', 'developer', 'enterprise']),
  sub_method: z.enum(['demonstration', 'evaluation']),
  first_name: z.string().max(FORTY_CHARACTER_LIMIT).min(1, 'form.Required field'),
  last_name: z.string().max(EIGHTY_CHARACTER_LIMIT).min(1, 'form.Required field'),
  email: z
    .string()
    .min(1, 'form.Required field')
    .email('form.Invalid email format')
    .max(EIGHTY_CHARACTER_LIMIT)
    .transform((value) => value.toLowerCase())
    .refine(
      (value) => !excludedEmailDomains.some((domain) => value.includes(domain)),
      'form.Company email domains only'
    ),
  company: z.string().max(FORTY_CHARACTER_LIMIT).min(1, 'form.Required field'),
  phone: z.string().max(FORTY_CHARACTER_LIMIT).optional(),
  country: z
    .object({
      label: z.string(),
      value: z.string(),
    })
    .nullable()
    .transform((data, ctx) => {
      if (data === null) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'form.Required field',
        });

        return z.NEVER;
      }

      return data.value;
    }),
  currency: z.enum(['USD', 'EUR']),
  number_of_developers: z
    .object({
      label: z.string(),
      value: z.string(),
    })
    .nullable()
    .transform((data, ctx) => {
      if (data === null) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'form.Required field',
        });

        return z.NEVER;
      }

      return data.value;
    }),
  uses_sonarqube: z.boolean(),
  referral_code: z.string(),
  campaign_id: z.string().optional(),
  ...marketingOptOutSchema.shape,
});
